import React from 'react';
import { Hotel, Headphones, Car, FileCheck } from 'lucide-react';
import { services } from '../data/mockData';
import { Button } from './ui/button';

const ServicesSection = ({ onOpenBuilder }) => {

  const getIcon = (iconName) => {
    switch (iconName) {
      case 'hotel':
        return <Hotel className="w-8 h-8 text-[#d4af37]" />;
      case 'support':
        return <Headphones className="w-8 h-8 text-[#d4af37]" />;
      case 'transport':
        return <Car className="w-8 h-8 text-[#d4af37]" />;
      case 'visa':
        return <FileCheck className="w-8 h-8 text-[#d4af37]" />;
      default:
        return null;
    }
  };

  return (
    <section id="services" className="py-20 bg-[#f8f9fa]">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <span className="text-[#d4af37] font-medium tracking-wider">OUR SERVICES</span>
            <h2 
              className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 mt-2"
              style={{ fontFamily: 'Playfair Display, Georgia, serif' }}
            >
              What ZamZam Umrah Offers
            </h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              We offer the cheapest Umrah packages online with premium hotels in Makkah 
              and Madinah, comfortable ground transport, and hassle-free visa processing.
            </p>

            <ul className="space-y-3 mb-8">
              <li className="flex items-center gap-2">
                <span className="text-green-500">✔</span>
                <span className="text-gray-700">Hand-picked hotels near Holy Mosques</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="text-green-500">✔</span>
                <span className="text-gray-700">Comfortable airport & inter-city transfers</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="text-green-500">✔</span>
                <span className="text-gray-700">Fast-track Umrah visa processing</span>
              </li>
              <li className="flex items-center gap-2">
                <span className="text-green-500">✔</span>
                <span className="text-gray-700">Ziyarat tours to sacred sites</span>
              </li>
            </ul>

            <div className="flex gap-4">
              <Button
                onClick={onOpenBuilder}
                className="bg-[#d4af37] text-black hover:bg-[#c4a030] font-bold px-6"
              >
                BUILD YOUR UMRAH
              </Button>
              <Button
                variant="ghost"
                className="text-gray-700 hover:bg-gray-200 font-bold"
              >
                LEARN MORE
              </Button>
            </div>

            {/* Service Features */}
            <div className="grid grid-cols-2 gap-6 mt-12">
              {services.map((service) => (
                <div key={service.id} className="flex gap-4">
                  <div className="w-14 h-14 bg-white rounded-lg shadow-md flex items-center justify-center flex-shrink-0">
                    {getIcon(service.icon)}
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900">{service.title}</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      {service.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <img
              src="https://images.pexels.com/photos/3890524/pexels-photo-3890524.jpeg?auto=compress&cs=tinysrgb&w=800"
              alt="Masjid Nabawi"
              className="w-full h-auto rounded-lg shadow-xl"
            />
            {/* Umrah Only Badge */}
            <div className="absolute -bottom-4 -left-4 bg-[#d4af37] text-black px-6 py-3 rounded-lg shadow-lg">
              <p className="font-bold">100% Umrah Focused</p>
              <p className="text-sm">No Flight Booking Required</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
